import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import StatusTable from "../../components/Tables/StatusTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
class Status extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewStatusPermission = userPermissions.includes('new setting service status');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Servis Durumları"
                Breadcrumb={[
                  {name: "Ayarlar", navigate: ""},
                  {name: "Servis durumları", navigate: ""},
                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task">
                  <div className="header">
                    <h2>Servis durumları</h2>
                    {userHasNewStatusPermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/statu-add">Yeni servis durumu</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}

                  </div>
                  <div className="body">
                    <StatusTable>

                    </StatusTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                  #dropdown-basic::after {
                      display: none;                                                     
                  }
                `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(Status)));
